import './toggle_visibility_component.css'
import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    start: String,
    hideAfter: Number,
    showAfter: Number,
  }

  initialize() {
    this.setupVisibilityToggle()
  }

  setupVisibilityToggle() {
    const startVisible = this.startValue === 'visible'

    if (startVisible && this.hideAfterValue > 0) {
      setTimeout(() => {
        this.element.classList.add('builder-toggle-visibility--hidden')
        this.announceVisibilityChange()
        this.pauseMedia()
      }, this.hideAfterValue * 1000)
    } else if (!startVisible && this.showAfterValue > 0) {
      setTimeout(() => {
        this.element.classList.remove('builder-toggle-visibility--hidden')
        this.announceVisibilityChange()
      }, this.showAfterValue * 1000)
    }
  }

  // Inputs in a hidden node are disabled by builder--input-visibility, which only re-checks on
  // resize and modals. Tell it the node just flipped so inputs submit (or stop) to match.
  announceVisibilityChange() {
    this.element.dispatchEvent(
      new CustomEvent('builder:visibility-changed', { bubbles: true })
    )
  }

  // Hiding with `display: none` doesn't stop playback, so a playing video/audio
  // keeps producing phantom audio. Pause it when the node hides.
  pauseMedia() {
    // Media renders as Video.js players, with the id on the .video-js wrapper —
    // pause through the player API (like we stop players elsewhere), since a raw
    // element.pause() can be reasserted by the player.
    this.element.querySelectorAll('.video-js').forEach((el) => {
      window.videojs?.getPlayer(el.id)?.pause()
    })

    // Fallback for any native media Video.js isn't managing (e.g. .no-video-js).
    this.element.querySelectorAll('video, audio').forEach((el) => {
      if (!el.paused) el.pause()
    })
  }
}
